module.exports = __webpack_public_path__ + "img/upload-btn.4f4e7b68.svg";